export default __webpack_public_path__ + "static/media/testimonial01.ef527bf3.png";